// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputDateTime,
  InputDoubleButton,
  InputNumber,
} from '@vroskus/library-components';

// Types
import type {
  $ReducerState,
} from '../../../redux';

export type $OwnProps = $Translate & {
  item: $Model<'RegattaCourseRace'> | $ModelUpsertParams<'RegattaCourseRace'>;
};

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = Record<string, unknown>;

type $Props = $DispatchProps & $OwnProps & $StateProps;

const RegattaCourseRaceFieldsView = function ({
  item,
  main,
  t,
}: $Props) {
  return (
    <Row>
      <Col
        xs={8}
      >
        <InputDoubleButton
          className={'mb-3'}
          label={t('Visibility')}
          labelFalse={t('Hidden')}
          labelTrue={t('Visible')}
          name={'Public'}
          value={item.Public}
        />
      </Col>
      <Col
        xs={4}
      >
        <InputNumber
          label={t('Interval')}
          min={3}
          name={'UpadateInterval'}
          required
          value={item.UpadateInterval}
        />
      </Col>
      <Col
        xs={12}
      >
        <AvField
          label={t('Title')}
          name={'Name'}
          required
          value={item.Name}
        />
      </Col>
      <Col
        xs={12}
      >
        <InputDateTime
          label={t('Start date')}
          labelOpenCalendar={t('Open calendar')}
          name={'StartDate'}
          required
          timezone={main.timezone}
          value={item.StartDate}
        />
      </Col>
      <Col
        xs={12}
      >
        <InputDateTime
          label={t('End date')}
          labelOpenCalendar={t('Open calendar')}
          name={'EndDate'}
          required
          timezone={main.timezone}
          value={item.EndDate}
        />
      </Col>
    </Row>
  );
};

export default RegattaCourseRaceFieldsView;
